// extracted by mini-css-extract-plugin
export default {"addMoneyAndDelinkWalletContainer":"di2K2v","addMoneyAndDelinkWalletHeader":"qYcvRC"};